<template>
	<b-alert
		:show="dismissCountDown"
		dismissible
		variant="warning"
		@dismissed="dismissCountDown=0"
		@dismiss-count-down="countDownChanged"
	>
		<p>{{ deleteErrorMessage }}</p>
	</b-alert>
</template>

<script>
    export default {
        name: "NotAllowedAlert",
		props: {
			/*notAllowedError: {
				type: Boolean,
				default: false
			},*/
			deleteErrorMessage: {
				type: String,
				default: 'There is something wrong ...'
			}
		},
		data () {
        	return {
				dismissCountDown: 4,
			}
		},
		methods: {
			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
		}
    }
</script>

<style scoped>

</style>
